import type { Tone } from '@/components/ui';

/** How loans read on screen. */

export const LOAN_KIND_LABEL: Record<string, string> = {
  TERM: 'Term loan',
  WORKING_CAPITAL: 'Working capital',
  VEHICLE: 'Vehicle loan',
  EQUIPMENT: 'Equipment loan',
  OTHER: 'Other',
};

export const LENDER_KIND_LABEL: Record<string, string> = {
  BANK: 'Bank',
  NBFC: 'NBFC',
  OTHER: 'Other',
};

export const FREQUENCY_LABEL: Record<string, string> = {
  MONTHLY: 'Monthly',
  QUARTERLY: 'Quarterly',
  HALF_YEARLY: 'Half-yearly',
  YEARLY: 'Yearly',
};

export const REPAYMENT_MODE_LABEL: Record<string, string> = {
  AUTO_DEBIT: 'Auto-debit',
  BANK_TRANSFER: 'Bank transfer',
};

export const LOAN_STATUS: Record<string, { label: string; tone: Tone }> = {
  DRAFT: { label: 'Draft', tone: 'neutral' },
  ACTIVE: { label: 'Active', tone: 'progress' },
  CLOSED: { label: 'Closed', tone: 'positive' },
  CANCELLED: { label: 'Cancelled', tone: 'neutral' },
};

export const ITEM_STATUS: Record<string, { label: string; tone: Tone }> = {
  SCHEDULED: { label: 'Scheduled', tone: 'neutral' },
  IN_PAYMENT_QUEUE: { label: 'In Payment Queue', tone: 'progress' },
  AWAITING_DEBIT: { label: 'Awaiting debit', tone: 'attention' },
  OVERDUE: { label: 'Overdue', tone: 'negative' },
  PAID: { label: 'Paid', tone: 'positive' },
};

/** 950 → "9.5%". */
export function ratePercent(basisPoints: number | undefined): string {
  return basisPoints === undefined ? '—' : `${basisPoints / 100}%`;
}
